import { VoidFunctionComponent } from 'react';
import { Text } from '@react-three/drei';
import { Screen } from '@/components/Screen';
import { useResponsive } from '@/hooks/useResponsive';
import { garamondNarrowLight } from '@/lib/fonts';
import { PlaystationButton } from '@/components/PlaystationButton';
import { BUY_URL } from '@/lib/globals';

interface Props {
    quizPreview: boolean;
    previewQuiz: () => void;
    cancel: () => void;
}
export const IncubatorClosed: VoidFunctionComponent<Props> = ({ quizPreview, previewQuiz, cancel }) => {
    const { responsiveValue } = useResponsive();
    const textProps = {
        textAlign: 'center' as const,
        font: garamondNarrowLight,
        fontSize: responsiveValue(0.36, 0.28),
        color: 'white',
        maxWidth: responsiveValue(5.7, 3.3),
        lineHeight: responsiveValue(1.1, 1.1),
    };

    return (
        <Screen>
            <Text position={[0, responsiveValue(0.5, 0.5), 0]} {...textProps}>
                The incubator is now closed.
            </Text>
            <group
                position={
                    quizPreview
                        ? [responsiveValue(-1.8, -1.6), responsiveValue(-1.7, -1.9), 0]
                        : [responsiveValue(-0.8, -0.7), responsiveValue(-1.0, -1.9), 0]
                }
                scale={responsiveValue(1, 0.85)}
            >
                <PlaystationButton
                    clickableAreaDimensions={[4, 0.7]}
                    maxWidth={4}
                    position={quizPreview ? [0, 1.0, 0] : [-1.0, 0, 0]}
                    icon="square"
                    label="ONLYBOTS MARKETPLACE"
                    action={() => {
                        window.location.href = BUY_URL;
                    }}
                />
                {quizPreview && (
                    <PlaystationButton
                        clickableAreaDimensions={[3.3, 0.7]}
                        position={[0, 0.2, 0]}
                        icon="triangle"
                        label="TRY QUIZ ANYWAY"
                        action={previewQuiz}
                    />
                )}
                <PlaystationButton
                    clickableAreaDimensions={[3, 0.7]}
                    position={quizPreview ? [0, -0.6, 0] : [responsiveValue(0.1, 0), responsiveValue(-0.8, -1), 0]}
                    icon="x"
                    label={'CANCEL'}
                    action={cancel}
                />
            </group>
        </Screen>
    );
};
